module.exports = __webpack_public_path__ + "img/schema_selle_2b.878f11b1.svg";